import React from 'react';
import { withApollo } from "react-apollo";

import { ColHead } from '../chunk';
import { getFileKey, getRandomAffordance } from '../../util';
import { Upload, UploadPreview } from "../upload";

class PostEdit extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			body: '',
			files: [],
            hasBody: false,
            hasFiles: false
		};

    	//this.handleSubmit = this.handleSubmit.bind(this);
    	this.handleFileRemove = this.handleFileRemove.bind(this);
    	this.setFiles = this.setFiles.bind(this);
    	//this.postComment = this.postComment.bind(this);
    	//this.postFiles = this.postFiles.bind(this);
	}

	// handleSubmit(e) {
	// 	e.preventDefault();

	// 	const dat = this;
	// 	const { hasFiles, hasBody } = this.state;
	// 	const channelID = this.props.channel;
	// 	const replyID = this.props.reply;		
	// 	const refetchQueries = [{
	// 		query: channel,
	// 		variables: { id: channelID }
	// 	}];

	// 	const postData = {
	// 		parent: replyID || channelID,
	// 		body: this.state.body
	// 	}
		
	// 	if(replyID) {
	// 		refetchQueries.push({
	// 			query: comment,
	// 			variables: { id: replyID }
	// 		});
	// 	}

	// 	//@TODO
	// 	if(hasFiles && hasBody) {

	// 		this.postFiles()
	// 			.then(res => {

	// 				const fileID = res.data.id;
	// 				dat.setState({
	// 					files: dat.state.files.map(f => Object.assign(f, {id: fileID}))
	// 				}, () => {
						
	// 					postData.file = dat.state.files[0].id;
	// 					dat.postComment(postData, refetchQueries)
	// 						.then(() => {

	// 							dat.setState({
	// 								files: [], 
	// 								hasFiles: false
	// 							})
	// 						});
	// 				})
	// 			})
			
	// 	} else if(hasFiles) {
	// 		alert('Image-only noch nicht möglich, bitte Nachricht eingeben.')
	// 	} else if(hasBody) {
	// 		this.postComment(postData, refetchQueries);
	// 	}
	// }

	setFiles(files) {
		files.map(f => { f.key = getFileKey(f); return f; })
		this.setState({
			files, hasFiles: (files.length > 0)
		})
	}

	handleFileRemove(filekey) {
		let files = this.state.files;
		const index = files.findIndex(f => f.key === filekey);
		if(index > -1) files.splice(index, 1);
		this.setState({
			files, hasFiles: (files.length > 0)
		});
	}


	// postComment(variables, refetchQueries) {
	// 	return this.props.client.mutate({
	// 		mutation: addComment,
	// 		variables,
	// 		refetchQueries
	// 	})
	// 	.then(res => {
	// 		this.setState({
	// 			body: '',
	// 			hasBody: false
	// 		});
	// 	})
	// 	.catch(e => {
	// 		alert('Post Error: ' + e);
	// 	});
	// }

	// postFiles() {
	// 	const files = this.state.files;
	// 	const parent = this.props.reply || this.props.channel;
	// 	return postUpload({files, parent});
	// }

	
	render() {

		const placeholder = getRandomAffordance();

		return (
			<div className="col col-2">

				<form className="post" onSubmit={this.handleSubmit}>
					<ColHead icon="comments" title="Tasty tasty tasty!"  />
					
					<textarea className="post-textarea" placeholder={placeholder}
					value={this.state.body} onChange={(e) => this.setState({body: e.target.value})}></textarea>

					{this.state.hasFiles && 
						<div className="post-attachments">
							<UploadPreview handleRemove={this.handleFileRemove} files={this.state.files} />
						</div>
					}{!this.state.hasFiles && <div></div>}

					<div className="button-wrap">
						<Upload button setFiles={this.setFiles} />
						{(this.state.hasBody || this.state.hasFiles) && 
							<button className="button button--cta" type="submit">veröffentlichen</button>
						}
					</div>
				</form>
			</div>
		);
	}
}

export default withApollo(PostEdit)


// WEBPACK FOOTER //
// ./src/components/post/PostEdit.js